module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h1>Select Icon</h1>\n<p>\n    Choose an icon to display on your offer in Joinos\n</p>\n<br/>\n<div class="image-hook"></div>\n<button class="pull-right button button-secondary close-button">\n    Close\n</button>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./offers/templates/image-dialog.html
// module id = 298
// module chunks = 0